import * as valueFunctions from './value';
import logic, { logicOr, logicAnd } from './logic';

const PARAMS_SEPARATOR = '.';

export const getFilterByFn = functionsMap =>
    (paramsString) => (
        applyOnEachProp(fn => filterWrapperFn(
            fn, parseFilterParams(paramsString)
        ), functionsMap)
    );

const filterWrapperFn = (fn, params) =>
    (...args) => params
        .reduceRight((acc, param) => ({
            ...getFilterParam(param),
            source: [acc]
        }), fn(...args));

/**
 * Применяет prepareFunction на каждое значение из propertiesMap
 *
 * @param prepareFunction
 * @param propertiesMap
 * @returns {{}}
 */
const applyOnEachProp = (prepareFunction, propertiesMap) => (
    Object.entries(propertiesMap)
        .map(([key, fn]) => [key, prepareFunction(fn)])
        .reduce((acc, [key, fn]) => ({ ...acc, [key]: fn }), {})
);

const getFilterParam = param => ({
    type: 'FILTER',
    value: param
});

const parseFilterParams = paramsString => paramsString.split(PARAMS_SEPARATOR);

const filteringFunctionsMap = {
    ...valueFunctions,
    logic,
    logicAnd,
    logicOr
};

export default getFilterByFn(filteringFunctionsMap);
